import { handleActions } from "redux-actions";
import { setAuthCurrentPermissions } from "../actions/actions";

export default handleActions(
  {
    [setAuthCurrentPermissions]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
